export enum AccessStatus {
  INVITATION_SENT = 'INVITATION_SENT',
  IN_PROGRESS = 'IN_PROGRESS',
  ABORTED = 'ABORTED',
  COMPLETED = 'COMPLETED'
}

export enum AccessStatusOriginal {
  INVITATION_SENT,
  INITIATED,
  IN_PROGRESS,
  COMPLETED,
  ABORTED,
}
